(function () {
  'use strict';


  function initWishlistButtons(swat) {
    var buttons = document.querySelectorAll('.wishlist-btn.ar-pc');
    if (!buttons.length) return;

    swat.fetch(function (wishlist) {
      var inWishlist = new Set((wishlist || []).map(function (item) { return item.empi; }));
      buttons.forEach(function (btn) {
        if (inWishlist.has(parseInt(btn.dataset.productId, 10))) {
          btn.classList.add('is-wishlisted');
        }
        addToggleHandler(btn, swat);
      });
    }, function () {
      buttons.forEach(function (btn) { addToggleHandler(btn, swat); });
    });
  }

  function addToggleHandler(btn, swat) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var productId  = parseInt(btn.dataset.productId, 10);
      var variantId  = parseInt(btn.dataset.variantId, 10);
      var productUrl = btn.dataset.productUrl;
      var card       = btn.closest('product-card');
      var title      = card ? (card.querySelector('.product-title') || {}).textContent || '' : '';
      var img        = card ? (card.querySelector('img') || {}).src || '' : '';

      if (btn.classList.contains('is-wishlisted')) {
        swat.removeFromWishList(
          { empi: productId, epi: variantId, du: productUrl },
          function () { btn.classList.remove('is-wishlisted'); },
          function () {}
        );
      } else {
        swat.addToWishList(
          { empi: productId, epi: variantId, du: productUrl, dt: title.trim(), iu: img, pr: 0 },
          function () { btn.classList.add('is-wishlisted'); },
          function () {}
        );
      }
    });
  }

  // ── Wishlist page ─────────────────────────────────────────────────────────

  function mountCard(card, item, swat, grid, empty, actions) {
    card.dataset.swymEmpi = item.empi;
    card.dataset.swymEpi  = item.epi;
    card.dataset.swymDu   = item.du;
    var btn = card.querySelector('.wishlist-btn');
    if (btn) {
      btn.classList.add('is-wishlisted');
      addRemoveHandler(btn, item, card, swat, grid, empty, actions);
    }
    grid.appendChild(card);
  }

  function fetchCard(item, swat, grid, empty, actions) {
    var handle = item.du.replace(/^https?:\/\/[^/]+/, '').replace(/^\/products\//, '').split('?')[0];
    return fetch('/products/' + handle + '?sections=product-card-pool')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['product-card-pool'] || '';
        var card = tmp.querySelector('product-card');
        if (card) mountCard(card, item, swat, grid, empty, actions);
      })
      .catch(function () {});
  }

  function initWishlistPage(swat) {
    var grid    = document.getElementById('wishlist-grid');
    var loading = document.getElementById('wishlist-loading');
    var empty   = document.getElementById('wishlist-empty');
    var actions = document.getElementById('wishlist-actions');
    if (!grid) return;

    swat.fetch(function (wishlist) {
      loading.hidden = true;

      if (!wishlist || wishlist.length === 0) {
        empty.hidden = false;
        return;
      }

      grid.hidden = false;
      if (actions) actions.hidden = false;
      initClearButton(swat, grid, empty, actions, wishlist);
      initShareButton(swat);

      Promise.all(wishlist.map(function (item) {
        return fetchCard(item, swat, grid, empty, actions);
      })).then(function () {
        if (!grid.querySelector('product-card')) {
          grid.hidden = true;
          if (actions) actions.hidden = true;
          empty.hidden = false;
        }
      });
    }, function () {
      loading.hidden = true;
      empty.hidden = false;
    });
  }

  function initClearButton(swat, grid, empty, actions, wishlistItems) {
    var btn = document.getElementById('wishlist-clear-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      btn.disabled = true;
      var total = wishlistItems.length;
      var removed = 0;

      wishlistItems.forEach(function (item) {
        var card = grid.querySelector('[data-swym-empi="' + item.empi + '"]');

        swat.removeFromWishList(
          { empi: item.empi, epi: item.epi, du: item.du },
          function () {
            if (card) card.remove();
            removed++;
            if (removed >= total) {
              grid.hidden = true;
              if (actions) actions.hidden = true;
              empty.hidden = false;
            }
          },
          function () {
            // On error: just count it so button doesn't stay frozen
            removed++;
            if (removed >= total) {
              // Not all removed — reload to show real state
              window.location.reload();
            }
          }
        );
      });
    });
  }

  function initShareButton(swat) {
    var btn = document.getElementById('wishlist-share-btn');
    if (!btn) return;

    var SHARE_ICON =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>' +
      '<line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>' +
      '</svg> ';

    var shareLabel  = btn.dataset.label       || 'Share';
    var copiedLabel = btn.dataset.copiedLabel || 'Link copied!';

    btn.addEventListener('click', function () {
      swat.generateSharedWishlistURL('My Wishlist', function (url) {
        if (navigator.share) {
          navigator.share({ url: url }).catch(function () {});
        } else {
          navigator.clipboard.writeText(url).then(function () {
            btn.textContent = copiedLabel;
            setTimeout(function () { btn.innerHTML = SHARE_ICON + shareLabel; }, 2000);
          }).catch(function () {});
        }
      }, function () {
        if (navigator.share) {
          navigator.share({ url: window.location.href }).catch(function () {});
        } else {
          navigator.clipboard.writeText(window.location.href).catch(function () {});
        }
      });
    });
  }

  function addRemoveHandler(btn, item, card, swat, grid, empty, actions) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      swat.removeFromWishList(
        { empi: item.empi, epi: item.epi, du: item.du },
        function () {
          card.remove();
          if (!grid.querySelector('product-card')) {
            grid.hidden = true;
            if (actions) actions.hidden = true;
            empty.hidden = false;
          }
        },
        function () {}
      );
    });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    if (document.getElementById('wishlist-grid')) {
      initWishlistPage(swat);
    } else {
      initWishlistButtons(swat);
    }
  });

}());
